import React from "react";
import Navbar from "../../components/common/navbar/Navbar";
import NewSales from "../../components/sales/NewSales";
import { useLocation } from "react-router-dom";

const NewSalesPage = () => {
    const { state } = useLocation();
    const [activeTab, setActiveTab] = React.useState("fast"); // 'manual' | 'fast'
    const tabSwitcher = (
        <div className="btn-group" role="group">
            <button
                type="button"
                className={`btn ${activeTab === "fast" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setActiveTab("fast")}
                style={{ width: "120px", fontSize: "13px" }}
            >
                Fast Billing
            </button>
            <button
                type="button"
                className={`btn ${activeTab === "manual" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setActiveTab("manual")}
                style={{ width: "120px", fontSize: "13px" }}
            >
                Manual
            </button>
        </div>
    );

    return (
        <>
            <section className="bajaj_main_block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <Navbar
                                content={(state?.orderId || state?.id) ? "EDIT ORDER" : "NEW ORDER"}
                                centerContent={tabSwitcher}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <NewSales activeTab={activeTab} />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default NewSalesPage;
